import React from "react";
import POExceptionMgmtBuyer from "./POExceptionMgmtBuyer";
import POExceptionMgmtSupplier from "./POExceptionMgmtSupplier";

const POExceptionManagement = () => {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "Global Planner" || userRole === "Regional Planner" || userRole === "Global Viewer" || userRole === "Regional Viewer") {
        return <POExceptionMgmtBuyer />;
    }

    if (
        userRole === "Supplier" ||
        userRole === "Supplier Planner" ||
        userRole === "Supplier Admin" || userRole === "App Admin"
    ) {
        return <POExceptionMgmtSupplier />;
    }

    return null;
};

export default POExceptionManagement;
